import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { fetchTerms } from "../../api/legalApi";
import "./Terms.css";

export default function TermsAndConditions() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchTerms()
      .then(setData)
      .catch((err) => console.error("Error fetching terms:", err));
  }, []);

  if (!data) return <div className="legal-page">Loading...</div>;

  return (
    <div className="legal-page">
      <Helmet>
        <title>Terms & Conditions | 164 Diecast Zone</title>
        <meta
          name="description"
          content="Read the Terms and Conditions governing your use of the 164 Diecast Zone website and services."
        />
        <link rel="canonical" href="https://164diecastzone.com/terms-and-conditions" />
        <meta property="og:title" content="Terms & Conditions | 164 Diecast Zone" />
        <meta property="og:url" content="https://164diecastzone.com/terms-and-conditions" />
      </Helmet>
      <div className="legal-container">
        <h1>Terms & Conditions</h1>
        <div className="legal-meta">Last updated: {data.last_updated}</div>

        <p>
          These Terms and Conditions govern your use of the
          <strong> 164diecastzone </strong> website and services.
        </p>

        <ul>
          <li>You must provide accurate and complete information</li>
          <li>Orders are subject to availability and confirmation</li>
          <li>Prices and products may change without notice</li>
          <li>Unauthorized use of this website is prohibited</li>
        </ul>

        <div className="legal-buttons">
          <a href={data.file_url} target="_blank" rel="noopener noreferrer">
            View Terms
          </a>
          <a href={data.file_url} download>
            Download Terms
          </a>
        </div>
      </div>
    </div>
  );
}
